<template>
    <NuxtImg
        :src="src"
        :alt="alt"
        class="article__banner"
        :width="crop?.width"
        :height="crop?.height"
        fit="cover"
        format="auto"
        sizes="xs:100vw sm:100vw md:768px"
        loading="eager"
        fetchpriority="high"
        :preload="{ fetchPriority: 'high' }"
    />
</template>

<script setup>
import storyblokImageSize from '~/helpers/storyblokImageSize'

const props = defineProps({
    src: {
        type: String,
        required: true,
    },

    alt: {
        type: String,
        required: true,
    },
})

// This is the LCP element on every article page — the same role the gallery
// plays on tour pages (photo-gallery.vue, measured ~1.6s LCP win). Eager +
// fetchpriority + the `preload` prop come as a set; the preload <link> is
// emitted by NuxtImg itself with imagesrcset/imagesizes, so it byte-matches
// the rendered srcset by construction.
//
// width/height derive from the intrinsic width at the CSS crop ratio
// (`.article__banner { aspect-ratio: 2 / 1.05 }` in article.scss), so the
// transform (`fit=cover`), the CLS-reserving attrs and the CSS box all agree —
// Cloudflare ships exactly the pixels the box displays.
const dims = computed(() => storyblokImageSize(props.src))

const crop = computed(() => dims.value && {
    width: dims.value.width,
    height: Math.round(dims.value.width * 1.05 / 2),
})
</script>
